import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  return <section id="testimonios" className="py-16 px-4 md:px-8 lg:px-16 bg-white" data-id="element-345">
      <div className="max-w-7xl mx-auto" data-id="element-346">
        <div className="text-center mb-16" data-id="element-347">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-indigo-900" data-id="element-348">
            Historias de Transformación Real
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-349">
            Estas son algunas de las más de 1,200 personas que ya han
            experimentado el poder transformador de 30 Días Frecuencia
            Prohibida.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-350">
          {[{
          name: 'María Rodríguez',
          location: 'Bogotá, Colombia',
          image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
          quote: 'Antes me sentía constantemente ansiosa y sin energía. Después de los 30 días, mi vida dio un giro completo. Ahora atraigo oportunidades que antes ni soñaba, mi energía está por las nubes y finalmente pude iniciar el negocio que tanto deseaba. ¡Es como si hubiera desbloqueado una nueva versión de mí misma!'
        }, {
          name: 'Carlos Mendoza',
          location: 'Ciudad de México',
          image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
          quote: 'Llevaba años intentando diferentes métodos de desarrollo personal sin resultados duraderos. Este programa fue completamente diferente. Las frecuencias realmente funcionan a un nivel que no puedo explicar con palabras. Mi claridad mental, mi confianza y mi capacidad para manifestar han aumentado exponencialmente. Mi familia nota el cambio y mis ingresos se han duplicado.'
        }, {
          name: 'Lucía Fernández',
          location: 'Buenos Aires, Argentina',
          image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
          quote: 'Estaba escéptica al principio, pero decidí darle una oportunidad. Ya en la primera semana sentí un cambio profundo en mi energía. Al final de los 30 días, las personas tóxicas desaparecieron de mi vida, comencé a atraer relaciones nutritivas y encontré mi verdadero propósito. Las frecuencias prohibidas son realmente el secreto mejor guardado para una transformación auténtica.'
        }].map((testimonial, index) => <div key={index} className="bg-indigo-50 p-8 rounded-lg shadow-lg relative" data-id="element-351">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2" data-id="element-352">
                <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full border-4 border-white object-cover" data-id="element-353" />
              </div>
              <div className="pt-10" data-id="element-354">
                <div className="flex justify-center mb-4" data-id="element-355">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} size={18} className="fill-yellow-400 text-yellow-400" data-id="element-356" />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-357">
                  "{testimonial.quote}"
                </p>
                <div className="text-center" data-id="element-358">
                  <h4 className="font-bold text-indigo-900" data-id="element-359">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-360">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-16 text-center" data-id="element-361">
          <p className="text-xl font-bold text-indigo-900 mb-6" data-id="element-362">
            Únete a más de 1,200 personas que ya han transformado su frecuencia
            vibratoria
          </p>
          <a href="#inscripcion" className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-105" data-id="element-363">
            Quiero Resultados Como Estos
          </a>
        </div>
      </div>
    </section>;
}